import { clomp } from 'clomp';

export const Paragraph = clomp.p`
  text-gray-300
  text-subtitle
`;
